import React from 'react';
import styles from './ProblemSolving.module.css';
import man from './images/Male Memojis.svg';
import man2 from './images/Male Memojis (1).svg';
import man3 from './images/Male Memojis (2).svg';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
    OptimizedMotion,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const ProblemSolving: React.FC = () => {
    return (
        <section className={styles.problemSolvingSection}>
            <div className={styles.contentContainer}>
                <div className={styles.headerSection}>
                    <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                        <span className={styles.titleHighlight}>The Problem</span>{' '}
                        <span className={styles.wrenchIcon}>🔧</span> we're Solving
                    </OptimizedMotionH1>
                    <OptimizedMotionP className={styles.subtitle} type="slide-left" delay={0.4}>
                        Marketing teams are buried under content chaos. From off-brand messaging and
                        scattered version control to sluggish approvals and missed launch windows,
                        the system is broken.
                    </OptimizedMotionP>
                </div>

                <div className={styles.painPointsSection}>
                    <div className={styles.painPointsGrid}>
                        <OptimizedMotion
                            className={styles.painPointItem}
                            type="slide-left"
                            delay={0.2}
                        >
                            <div className={styles.iconContainer}>
                                <img src={man} />
                            </div>
                            <div className={styles.painPointContent}>
                                <h3 className={styles.painPointTitle}>Diluted Brand Voice</h3>
                                <p className={styles.painPointDescription}>
                                    Inconsistent tone and messaging across assets
                                </p>
                            </div>
                        </OptimizedMotion>

                        {/* Workflow Chaos */}
                        <OptimizedMotion
                            className={styles.painPointItem}
                            type="slide-down"
                            delay={0.4}
                        >
                            <div className={styles.iconContainer}>
                                <img src={man2} />
                            </div>
                            <div className={styles.painPointContent}>
                                <h3 className={styles.painPointTitle}>Workflow Chaos</h3>
                                <p className={styles.painPointDescription}>
                                    Siloed tools and disconnected processes
                                </p>
                            </div>
                        </OptimizedMotion>

                        {/* Approval Bottlenecks */}
                        <OptimizedMotion
                            className={styles.painPointItem}
                            type="slide-right"
                            delay={0.6}
                        >
                            <div className={styles.iconContainer}>
                                <img src={man3} />
                            </div>
                            <div className={styles.painPointContent}>
                                <h3 className={styles.painPointTitle}>Approval Bottlenecks</h3>
                                <p className={styles.painPointDescription}>
                                    Delayed launches due to scattered sign-offs
                                </p>
                            </div>
                        </OptimizedMotion>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProblemSolving;
